export default __webpack_public_path__ + "static/media/fixer.52cd52d6.png";